import { useContext } from "react";
import { ProjectOrganisationContext } from "./project-organisation-context-props.ts";

const useProjectOrganisationContext = () => {
    const context = useContext(ProjectOrganisationContext);
    if (!context) {
        throw new Error('useProjectOrganisationContext must be defined');
    }

    return context;
}

export default useProjectOrganisationContext;